import PaymentForm from 'CoreComponents/paymentForm/';

const SELECTOR = {
  paymentForm: '.form-payment'
};

class CheckoutPaymentScreen {
  constructor() {
    this._setup();
  }

  // Private Methods

  _setup() {
    document.querySelectorAll(SELECTOR['paymentForm']).forEach((element) => {
      new PaymentForm(element);
    });
  }
}

// Setup the CheckoutPaymentScreen class, only on the payments page.
let isCheckoutPaymentPage = document.body.classList.contains('checkout') && document.body.classList.contains('payments');

if (isCheckoutPaymentPage) {
  new CheckoutPaymentScreen();
}



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/screens/CheckoutPayment.js